import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { getUserListUrl, GET_USER_LIST_ACTION_TYPE, getUserDetailsUrl, GET_USER_DETAILS_ACTION_TYPE, addUpdateUserUrl, ADD_UPDATE_USER_ACTION_TYPE, deleteUserUrl, DELETE_USER_ACTION_TYPE, headers } from "../../utils/constants"
import moment from 'moment';

export const get_userList_action = (name, email, roleID, statusID) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('userId') != '' && sessionStorage.getItem('userId') != null ? sessionStorage.getItem('userId') : null,
            Name: name != '' ? name : null,
            Email: email != '' ? email : null,
            RoleID: roleID != '' ? roleID : null,
            StatusID: statusID != '' ? statusID : null,
        }
        console.log("data----------", mapdata)
        console.log("bookingDetailsList----------", getUserListUrl)
        const res = await axiosGet(getUserListUrl, mapdata,headers);

        dispatch({
            type: GET_USER_LIST_ACTION_TYPE,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const get_userDetails_action = (userId) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: userId
        }
        console.log("data----------", mapdata)
        console.log("bookingDetailsList----------", getUserDetailsUrl)
        const res = await axiosGet(getUserDetailsUrl, mapdata,headers);

        dispatch({
            type: GET_USER_DETAILS_ACTION_TYPE,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const addUpdate_user_action = (userId, name, email, phone, designation, Password, roleID, StatusID, cityList) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: userId != '' ? userId : null,
            Name: name,
            Email: email,
            Phone: phone,
            // DateOfBirth: dateOfBirth != null && dateOfBirth != '' && moment(dateOfBirth).format('MM-DD-YYYY'),
            Designation: designation,
            Password: Password,
            RoleID: roleID != '' ? roleID : null,
            CreateModifiedDeleteUserId: parseInt(sessionStorage.getItem('userId')),
            StatusID: StatusID,
            CityList: cityList != '' ? cityList : null
        }
        console.log("data----------", mapdata)
        console.log("bookingDetailsList----------", getUserDetailsUrl)
        const res = await axiosPost(addUpdateUserUrl, mapdata, headers);

        dispatch({
            type: ADD_UPDATE_USER_ACTION_TYPE,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const deleteUserList_action = (userId) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: userId,
            DeleteUserId: parseInt(sessionStorage.getItem('userId'))
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(deleteUserUrl, mapdata,headers);

        dispatch({
            type: DELETE_USER_ACTION_TYPE,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};